import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { getAppointmentsPath } from '@app/modules/Appointments/paths'
import { AuthSelectors } from '@app/modules/Auth'
import { NavBarEntry } from '@app/NavBar'
import { useNavBarCountersLazyQuery } from '@app/queries/NavBar/NavBarCounters.queries'

export function useNavbarEntries(): NavBarEntry[] {
  const lawyerId = useSelector(AuthSelectors.getUserId)
  const location = useLocation()

  const [count, { data }] = useNavBarCountersLazyQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      lawyerId
    }
  })

  useEffect(() => {
    count()
  }, [location])

  return [
    {
      counter: data?.openAppointments ?? 0,
      iconName: 'calender',
      title: 'Termine',
      EntryWrapper: ({ children }) => <Link to={getAppointmentsPath()}>{children}</Link>,
      active: /^\/termine/
    }
  ]
}
